import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  clearAll () {
    this.itemTargets.forEach(el => {
      const checkbox = el.querySelector('input[type="checkbox"]')
      checkbox.checked = false
    })
  }
}
